import React, { Suspense } from 'react';
import {
  createRootRouteWithContext,
  Outlet,
  HeadContent,
} from '@tanstack/react-router';
import { QueryClient } from '@tanstack/react-query';
import { Icons } from '@/components/icons';
import { cn } from '@/lib/utils';
import NotFound from '@/templates/NotFound';

const TanStackRouterDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null
    : React.lazy(() =>
        import('@tanstack/router-devtools').then((res) => ({
          default: res.TanStackRouterDevtools,
        })),
      );

const ReactQueryDevtools =
  process.env.NODE_ENV === 'production'
    ? () => null
    : React.lazy(() =>
        import('@tanstack/react-query-devtools').then((res) => ({
          default: res.ReactQueryDevtools,
        })),
      );

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  head: () => ({
    meta: [{ title: 'Fleet Flow' }],
  }),
  component: () => (
    <>
      <HeadContent />
      <Outlet />
      <Suspense>
        <TanStackRouterDevtools position="top-right" />
        <ReactQueryDevtools position="right" />
      </Suspense>
    </>
  ),
  pendingComponent: () => (
    <div
      className={cn(
        'h-[calc(100vh_-_theme(spacing.16))] mt-[_theme(spacing.16)]',
        'flex justify-center items-center',
      )}
    >
      <Icons.spinner className="h-8 w-8 animate-spin" />
    </div>
  ),
  notFoundComponent: NotFound,
});
